import { Helmet } from "react-helmet";
import Main from "../../../Layout/Main";
import { Row, Col, Card, Statistic, Input, Table, Modal, Button } from "antd";
import CheckCircleOutlined from "@ant-design/icons";
import { useState } from "react";
import "../ParamsControl/styles.css";
import { ParamsControlService } from "../../../../services/paramscontrol";
import { useSelector } from "react-redux";
import loadingSVG from "../../../../assets/images/loading.svg";
import ModalParams from "./components/ModalParams";
import { useParamsContext } from "../../../../Context/paramsContext";
import { useEffect } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

function ParamsControl(props) {
  const [showParamInfo, setShowParamInfo] = useState(false);
  const [nameShowing, setNameShowing] = useState("");
  const [ComapanyShowing, setCompanyShowing] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const [data, setData] = useState([]);
  const [paramData, setParamData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paramsErrors, setParamsErrors] = useState("");
  const [paramsOk, setParamsOk] = useState("");
  const [paramsAlert, setParamsAlert] = useState("");
  const [loadingResumo, setLoadingResumo] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 36,
    total: 0,
  });
  const [resumo, setResumo] = useState(false);
  const companies = useSelector((state) => state.companies);
  const breadcrumb = [
    { title: "TIC", path: props.modulePath },
    { title: "Controle de parâmetros", path: props.module + "/params_control" },
  ];
  const [filters, setFilters] = useState([]);
  const { Search } = Input;
  const [optionSelected, setOptionSelected] = useState("");

  const { shouldRefresh, refreshParams } = useParamsContext();

  const options = [
    { value: "Nome", key: "name" },
    { value: "Descrição", key: "description" },
    { value: "Valor", key: "value" },
  ];

  const columns = [
    {
      title: "Nome",
      key: "company",
      render: (_, record) => (
        <>
          {record?.results?.erro !== "0"
            ? "❌ "
            : record?.results?.alerts !== "0"
            ? "⚠️ "
            : "✅ "}
          {record.nome}
        </>
      ),
    },
  ];

  const getParamsInfo = async (filter) => {
    if (!optionSelected || !filter) {
      return;
    }

    try {
      setLoading(true);
      setSearchQuery(filter);

      const response = await ParamsControlService.getParamsInfo({
        params_type: optionSelected,
        params_name: filter,
        page: 1,
        limit: pagination.pageSize,
      });

      if (!response.data) {
        setLoading(false);
        setData([]);
        return;
      }

      setPagination({
        current: 1,
        pageSize: pagination.pageSize,
        total: response.data.parametros[0].empresas[0].total_count,
      });

      setData(response.data.parametros);
      setRawData(response);

      setParamsAlert(response.results.alerts);
      setParamsErrors(response.results.erro);
      setParamsOk(response.results?.ok);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTableChange = async (pagi) => {
    setLoading(true);

    const params = {
      params_type: optionSelected,
      params_name: searchQuery,
      page: pagi.current,
    };

    try {
      const response = await ParamsControlService.getParamsInfo(params);

      setData(response.data.parametros);

      setPagination({
        current: pagi.current,
        pageSize: 36,
        total: response.data.parametros[0].empresas[0].total_count,
      });
      setParamsAlert(response?.results?.alerts);
      setParamsErrors(response?.results?.erro);
      setParamsOk(response?.results?.ok);
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const detailParam = async (company_id, infoparam) => {
    try {
      setLoadingModal(true);

      const detail = await ParamsControlService.getInfoByCompany({
        company_id,
        infoparam,
      });

      setParamData({ detail });
      setLoadingModal(false);
    } catch (error) {
      console.log(error);
      setLoadingModal(false);
    }
  };

  const controlShowParamInfo = (company, nome) => {
    if (showParamInfo) {
      if (company !== ComapanyShowing) {
        setCompanyShowing(company);
        setNameShowing(nome);
        setShowParamInfo(true);
        return;
      }
      setShowParamInfo(false);
      setCompanyShowing("");
      setNameShowing("");
    } else {
      setShowParamInfo(true);
      setCompanyShowing(company);
      setNameShowing(nome);
    }
  };

  useEffect(() => {
    if (shouldRefresh) {
      getParamsInfo(searchQuery);

      refreshParams();
    }
  }, [shouldRefresh]);

  const companiesTable = ({ empresas }) => (
    <div style={{ backgroundColor: "white", padding: "12px" }}>
      {empresas?.map((empresa) => {
        const companyNames = {
          "03": "MORADA DA PAZ RN",
          "05": "MORADA DA PAZ PE",
          "07": "MORADA DA PAZ JOÃO PESSOA",
          "06": "FUNERÁRIA MORADA DA PAZ RECIFE",
          19: "MORADA DO CUIDADO",
          20: "AA1195 SERVIÇOS ADMINISTRATIVOS LTDA",
          16: "VILA PART",
        };

        const companyName = companyNames[empresa.empresa] || empresa.empresa;

        const statusColor =
          {
            ok: "#52c41a",
            alert: "#faad14",
            erro: "#f5222d",
          }[empresa.result] || "#d9d9d9";

        return (
          <>
            <div
              key={empresa.empresa}
              style={{
                padding: "3px",
                marginBottom: "3px",
                borderLeft: `4px solid ${statusColor}`,
                backgroundColor: "#fafafa",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() =>
                controlShowParamInfo(empresa?.empresa, empresa?.nome)
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "3px",
                }}
              >
                <h3 style={{ margin: 0, fontWeight: 600 }}>
                  {companyName}{" "}
                  {showParamInfo &&
                  ComapanyShowing === empresa?.empresa &&
                  nameShowing === empresa?.nome ? (
                    <DownOutlined />
                  ) : (
                    <UpOutlined />
                  )}{" "}
                </h3>

                <span
                  style={{
                    color: statusColor,
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                >
                  {empresa.result.toUpperCase()}
                </span>
              </div>
            </div>
            {ComapanyShowing === empresa?.empresa &&
              nameShowing === empresa?.nome && (
                <div
                  style={{
                    background: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px solid #eaeaea",
                    padding: "16px",
                    marginTop: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    fontFamily: "Arial, sans-serif",
                  }}
                >
                  <strong style={{ fontSize: "14px" }}>
                    {empresa.message}
                  </strong>
                  <div
                    style={{
                      display: "flex",
                      gap: "24px",
                      marginBottom: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    <div>
                      <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                        Valor
                      </div>
                      <div style={{ fontWeight: 500 }}>
                        {empresa.valor || "-"}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                        Valor Espanhol
                      </div>
                      <div style={{ fontWeight: 500 }}>
                        {empresa.valor_esp || "-"}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                        Valor Inglês
                      </div>
                      <div style={{ fontWeight: 500 }}>
                        {empresa.valor_eng || "-"}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      borderTop: "1px dashed #e0e0e0",
                      paddingTop: "12px",
                    }}
                  >
                    <div style={{ marginBottom: "10px" }}>
                      <div
                        style={{
                          fontSize: "0.85rem",
                          color: "#6c757d",
                          marginBottom: "4px",
                        }}
                      >
                        Descrição
                      </div>
                      <div style={{ lineHeight: 1.4 }}>
                        {empresa.descricao || "-"}
                      </div>
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <div
                        style={{
                          fontSize: "0.85rem",
                          color: "#6c757d",
                          marginBottom: "4px",
                        }}
                      >
                        Descrição Inglês
                      </div>
                      <div style={{ lineHeight: 1.4 }}>
                        {empresa.descricao_en || "-"}
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          fontSize: "0.85rem",
                          color: "#6c757d",
                          marginBottom: "4px",
                        }}
                      >
                        Descrição Espanhol
                      </div>
                      <div style={{ lineHeight: 1.4 }}>
                        {empresa.descricao_esp || "-"}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <Button
                      onClick={async () => {
                        setParamData({});
                        showModal();
                        await detailParam(empresa.empresa, empresa.nome);
                      }}
                    >
                      Atualizar Informações
                    </Button>
                  </div>
                </div>
              )}
          </>
        );
      })}
    </div>
  );

  const ParamItem = ({ label, value }) => (
    <div style={{ marginBottom: 12 }}>
      <span
        style={{
          display: "block",
          color: "#718096",
          fontSize: 12,
          fontWeight: 500,
          textTransform: "uppercase",
          letterSpacing: 0.5,
          marginBottom: 4,
        }}
      >
        {label}
      </span>
      <div
        style={{
          fontSize: 14,
          color: "#2d3748",
          fontWeight: 400,
          lineHeight: 1.5,
          padding: "4px 0",
          minHeight: 24,
        }}
      >
        {value || (
          <span style={{ color: "#a0aec0", fontStyle: "italic" }}>
            Não informado
          </span>
        )}
      </div>
    </div>
  );

  return (
    <>
      <Helmet>Controle de Parâmetros</Helmet>
      <Main moduleName={props.moduleName} breadcrumb={breadcrumb}>
        <Row justify={"center"} style={{ marginBottom: "1em" }}>
          <Col span={10} style={{ paddingRight: "0.5em" }}>
            <Search
              placeholder="Pesquisar.."
              enterButton
              onSearch={getParamsInfo}
            />
          </Col>
        </Row>
        <Row justify={"center"} style={{ marginBottom: "1rem" }}>
          <Col>
            {options.map((option) => (
              <button
                key={option.key}
                style={{ marginRight: "0.5em" }}
                onClick={() => setOptionSelected(option.key)}
                className={`select-button ${
                  optionSelected === option.key ? "selected" : ""
                }`}
              >
                {option.value}
              </button>
            ))}
          </Col>
        </Row>
        <Row justify={"center"} gutter={[8, 8]}>
          <Col xs={24} sm={12} lg={2}>
            <Card
              className={
                loadingInfo || filters.includes("ok") ? "" : "cardResumoPointer"
              }
              loading={loadingResumo}
            >
              <Card.Meta
                style={{ alignItems: "center", justifyContent: "center" }}
                avatar={
                  <CheckCircleOutlined
                    style={{ color: "#3f8600", fontSize: "6vh" }}
                  />
                }
                title="Ok"
                description={
                  <Statistic
                    value={paramsOk ? paramsOk : ""}
                    precision={0}
                    valueStyle={{ color: "#3f8600" }}
                  />
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={2}>
            <Card
              className={
                loadingInfo || filters.includes("erro")
                  ? ""
                  : "cardResumoPointer"
              }
              loading={loadingResumo}
            >
              <Card.Meta
                style={{ alignItems: "center", justifyContent: "center" }}
                avatar={
                  <CheckCircleOutlined
                    style={{ color: "#3f8600", fontSize: "6vh" }}
                  />
                }
                title="Erro"
                description={
                  <Statistic
                    value={paramsErrors ? paramsErrors : ""}
                    precision={0}
                    valueStyle={{ color: "#cf1322" }}
                  />
                }
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={2}>
            <Card
              className={
                loadingInfo || filters.includes("alert")
                  ? ""
                  : "cardResumoPointer"
              }
              loading={loadingResumo}
            >
              <Card.Meta
                style={{ alignItems: "center", justifyContent: "center" }}
                avatar={
                  <CheckCircleOutlined
                    style={{ color: "#3f8600", fontSize: "6vh" }}
                  />
                }
                title="Alerta"
                description={
                  <Statistic
                    value={paramsAlert ? paramsAlert : ""}
                    precision={0}
                    valueStyle={{ color: "#ffcc00" }}
                  />
                }
              />
            </Card>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Table
              onChange={handleTableChange}
              columns={columns}
              style={{ marginTop: "1em" }}
              rowKey={(record) => record.nome}
              pagination={pagination}
              loading={loading}
              dataSource={data}
              expandable={{
                expandedRowRender: (record) => companiesTable(record),
              }}
            />
          </Col>
        </Row>
        <Modal
          title={"Detalhes do Parâmetro"}
          open={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          width={"90%"}
          destroyOnClose={true}
        >
          {loadingModal ? (
            <>
              <div className="loading-centar">
                <img src={loadingSVG} alt="loading" height={80} />
              </div>
              <h2 className="text-loading">Carregando..</h2>
            </>
          ) : (
            <ModalParams data={paramData} refreshParent={refreshParams} />
          )}
        </Modal>
      </Main>
    </>
  );
}

export default ParamsControl;
